<div #carouselContainer class="p-d-flex p-jc-center p-ai-center p-flex-column p-mt-3">

      <div class="carousel-item-content">
        <div class="image-container">
          <img [src]="version.url" [alt]="version.version"  [ngClass]="{ 'flip-horizontal': version.isMirrored,  'product-img': !version.isMirrored}" />
        </div>
        <div class="version-label">{{ version.version }}</div>
      </div>

</div>